import { VStack, Spacing, colors, ColorIcon } from "goi_common";
import { Box } from "@chakra-ui/react";
import { icon } from "goi_common/src/constants/icon";

interface GoiIntroItemProps {
  iconName: keyof typeof icon;
  iconColor?: string;
  title: string;
  descriptions: string[];
}

const GOI_INTRO_ITEMS: GoiIntroItemProps[] = [
  {
    iconName: "icon-people",
    iconColor: colors.blue550,
    title: "전국 10만명의 선택",
    descriptions: ["출시 2년 만에 10만명의 고객님들이", "가입해주셨습니다."],
  },
  {
    iconName: "icon_Graphic_Write",
    title: "후기 평균 4.9점",
    descriptions: [
      "실제 장례를 경험한 1500명의",
      "고객 분들이 남겨주신 평균 만족도입니다",
    ],
  },
  {
    iconName: "icon_Logo_CCM",
    title: "소비자중심경영(CCM) 인증",
    descriptions: ["삼성전자, LG와 함께", "공정위 CCM 인증을 취득하였습니다."],
  },
  {
    iconName: "icon_Graphic_Building",
    title: "업계 최초 벤처투자 119억",
    descriptions: [
      "대기업과 투자기관이 인정한 성장성",
      "탄탄한 자본으로 운영 중입니다.",
    ],
  },
];

function GoiIntroItem({
  iconName,
  iconColor = "",
  title,
  descriptions,
}: GoiIntroItemProps) {
  return (
    <VStack width="100%">
      <Box
        width="48px"
        height="48px"
        borderRadius="8px"
        background={colors.gray50}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <ColorIcon name={iconName} size={32} color={iconColor} />
      </Box>

      <Spacing gap={16} />

      <Box className="subtitle_18_sb" color={colors.gray900}>
        {title}
      </Box>

      <Spacing gap={8} />

      {descriptions.map((desc, index) => (
        <Box key={index} className="body_14_r" color={colors.gray600}>
          {desc}
        </Box>
      ))}
    </VStack>
  );
}

export default function HomeV4GoiIntroSection() {
  return (
    <VStack width="100%" padding="80px 20px" background={colors.white}>
      <Box className="body_16_r" color={colors.gray600}>
        왜 고이인가요?
      </Box>
      <Spacing gap={6} />
      <Box className="subtitle_21_sb" color={colors.gray900}>
        10만명의 회원이 가입한
        <br />
        투명하고 정직한 장례 서비스
      </Box>

      <Spacing gap={40} />

      <VStack width="100%">
        {GOI_INTRO_ITEMS.map((item, index) => (
          <Box key={item.title} width="100%">
            <GoiIntroItem {...item} />
            {index < GOI_INTRO_ITEMS.length - 1 && (
              <>
                <Spacing gap={32} />
                <Box width="100%" height="1px" background={colors.gray200} />
                <Spacing gap={32} />
              </>
            )}
          </Box>
        ))}
      </VStack>
    </VStack>
  );
}
